<template>
  <div
    :class="['notification-item', { unread: !notification.read_at }]"
    @click="clickItem"
  >
    <template v-if="notification?.data?.image">
      <img
        :src="handleImage(notification?.data?.image)"
        alt="Notification Image"
        class="notification-image"
      />
    </template>
    <template v-else-if="notification?.data?.type === 'add-app-to-developer'">
      <div class="developer-icon" v-if="notification?.data?.item?.icon">
        <img
          :src="notification.data.item.icon"
          :alt="notification.data.item.name || 'icon'"
        />
      </div>
      <div v-else class="developer-icon no-icon">
        <span class="material-symbols-outlined">code_blocks</span>
      </div>
    </template>
    <div class="notification-details">
      <div class="notification-title">
        {{ notification.data.title }}
        <img :src="storeImage(notification.data.icon)" class="store-icon" />
        <div class="properties-container">
          <div v-if="!notification.read_at" class="unread-dot"></div>
        </div>
      </div>
      <div class="notification-message">
        <span class="small-title" style="display: block;">{{ notification?.data?.addtionalData?.developer?.developerName }}</span>
        <span style="display: block; margin-top: 5px;">{{ notification.data.message }}</span>
      </div>
      <div v-if="actionTags && isActionTags" class="action-tags">
        <span
          v-for="(tag, index) in actionTags.slice(0, maxTags)"
          :key="index"
          :class="['action-tag', 'info-icon', tag.class]"
        >
          {{ tag.label }}
        </span>
        <div
          v-if="actionTags.length > maxTags"
          class="action-more"
          :title="getMoreActionsTooltip(actionTags.slice(maxTags))"
        >
          ...
        </div>
      </div>
      <div class="created-at">
        {{ formatDate(notification.created_at) }}
      </div>
    </div>
    <div class="delete-container">
      <div v-if="isDelete" class="delete-icon" @click.stop="handleDelete">
        <span class="material-symbols-outlined">delete</span>
      </div>
    </div>
  </div>
</template>

<script>
import AppActionEnum from "@/enums/AppActionEnum";
import PlatformTypeEnum from "@/enums/PlatformTypeEnum";

export default {
  name: "NotificationItem",
  props: {
    notification: {
      type: Object,
      required: true,
    },
    isActionTags: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      maxTags: window.innerWidth <= 768 ? 1 : 3,
    };
  },
  computed: {
    actionTags() {
      const actions = this.notification.data?.addtionalData?.actions;
      if (!actions || typeof actions !== "object") {
        return [];
      }

      return Object.keys(actions).map((id) => {
        const fieldName = this.getFieldName(id);
        return {
          label: fieldName,
          class: this.getFieldClass(this.getFieldName(id)),
          id: id,
        };
      });
    },
  },
  methods: {
    handleImage(image) {
      switch (image) {
        case "3":
          return require("@/assets/img/other/list.png");
        default:
          return image;
      }
    },
    clickItem() {
      this.$emit("clickItem", this.notification.id);
    },
    formatDate(date) {
      if (!date) return "";
      const locale = localStorage.getItem("localeTime") || "en-US";
      return new Date(date).toLocaleDateString(locale);
    },
    storeImage(platform) {
      platform = PlatformTypeEnum.fromId(platform);
      let imageName = "";
      switch (platform) {
        case "Play Store":
          imageName = "playStore.png";
          break;
        case "App Store":
          imageName = "appStore.png";
          break;
        default:
          imageName = "appStore.png";
          break;
      }
      return require(`@/assets/img/stores/${imageName}`);
    },
    getFieldName(actionId) {
      return AppActionEnum.nameMap[actionId] || "Unknown";
    },
    getFieldClass(fieldName) {
      return `info-icon ${fieldName.toLowerCase().replace(/[\s'"]/g, "")}`;
    },
    getMoreFieldsTooltip(fields) {
      return fields.map((field) => this.formatFieldName(field.name)).join("\n");
    },
    formatFieldName(name) {
      return name
        .split(/(?=[A-Z])/)
        .join(" ")
        .toLowerCase()
        .replace(/\b\w/g, (l) => l.toUpperCase());
    },
    getMoreActionsTooltip(actions) {
      return actions
        .map((action) => {
          return this.getFieldName(action.id);
        })
        .join("\n\n");
    },
    handleDelete() {
      this.$emit("deleteItem", this.notification.id);
    },
  },
};
</script>

<style scoped>
.action-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}

.action-more {
  font-size: 14px;
  font-weight: bold;
  color: #5f6368;
}

.action-tag {
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 500;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  white-space: nowrap;
}

.properties-container {
  /* display: flex; */
  position: absolute;
  right: 0px;
  /* margin-right: 3px; */
  width: 27px;
  top: 13%;
  align-items: center;
  justify-content: space-between;
}

.delete-container {
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.delete-icon {
  cursor: pointer;
  color: #ff4444;
  margin-left: 0;
  padding: 4px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s, background-color 0.2s;
}

.delete-icon:hover {
  background-color: rgba(255, 68, 68, 0.1);
  transform: scale(1.1);
}

.delete-icon .material-symbols-outlined {
  font-size: 18px;
}

.notification-item {
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 5px 5px;
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid #eee;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

.unread {
  background: #eeeeee57;
}

.notification-item:hover {
  background-color: #f4f5fa;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-image {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 15%;
}

.notification-details {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.notification-title {
  /* display: flex;
  justify-content: space-between; */
  font-weight: bold;
  font-size: 0.9rem;
}

.notification-message {
  font-size: 12px;
  color: #555;
  margin-bottom: 5px;
}

.created-at {
  font-size: 12px;
  color: #999;
}

.store-icon {
  width: 15px;
  height: 15px;
  margin-left: 5px;
}

.loading {
  padding: 20px;
  text-align: center;
}

.no-notifications {
  padding: 20px;
  text-align: center;
  color: #777;
}

.badge {
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 2px 0px;
  font-size: 4px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
}

.unread-dot {
  width: 7px;
  height: 7px;
  background-color: red;
  border-radius: 50%;
}

.modal-header {
  display: none;
}

.modal-title-container {
  display: flex;
  justify-content: center;
}

.modal-divider {
  width: 70px;
  height: 4px;
  background: #ccc;
  border-radius: 2px;
  margin-top: 8px;
  cursor: pointer;
  display: none;
}

@media screen and (max-width: 768px) {
  .notification-item {
    padding: 12px 0px;
  }

  .notification-image {
    width: 35px;
    height: 35px;
  }

  .notification-title {
    font-size: 0.7rem;
  }

  .notification-message {
    font-size: 10px;
  }

  .action-tag {
    font-size: 9px;
  }

  .material-symbols-outlined {
    font-size: 13px !important;
  }
}

.developer-icon {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.developer-icon span {
  font-size: 16px;
}

.developer-icon.no-icon {
  background: #fff6ee;
  color: var(--logo-color);
}

.developer-icon img {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  object-fit: cover;
}

@media (max-width: 640px) {
  .developer-icon {
    width: 35px;
    height: 35px;
  }
}
</style>
